export enum SubscriptionStatus {
    Unknown = 'Unknown',
    Received = 'Received',
    Active = 'Active',
    Cancelled = 'Cancelled',
    Trial = 'Trial',
    Failed = 'Failed',
    Retired = 'Retired',
}
